export const example = async () => 'example data';
